export class WorkOrderCreateJobResultDto {
    newMaintenanceJobId: number;
}
